setTimeout(() => {
    const buttons = document.querySelectorAll('.opk-mobile');
    const form = document.querySelector('.opk-form');

    for (const button of buttons) {
        button.addEventListener('click', (el) => {
            localStorage.setItem('translation-lab-lang', el.target.value);
            form.submit();
        })
    }
}, 1000)

const shippingCartLogic = async (total) => {
    const response = await fetch('https://api.country.is/');
    const { country } = await response.json();
    const container = document.querySelector('.opk-free-shipping.cart');
    if (country === 'BE' || country === 'NL' || country === 'DE') {
        const amount_text = container.querySelector('.opk-free-shipping__text span');
        const minimum = Math.round(parseInt(container.dataset.minimum, 10) * (Shopify.currency.rate || 1));
        let percentage = 1;
        const remainingText = container.querySelector('.opk-free-shipping__text-remaining');
        const fullText = container.querySelector('.opk-free-shipping__text-full');
        const icon = container.querySelector('.opk-free-shipping__icon');
        if (total < minimum) {
            percentage = total / minimum;

            if (amount_text) {
                let remaining = minimum - total;
                amount_text.innerHTML = `€${remaining / 100}`;
            }
            remainingText.style.display = 'block';
            fullText.style.display = 'none';
            icon.classList.remove('full')
        } else {
            remainingText.style.display = 'none';
            fullText.style.display = 'block';
            icon.classList.add('full')
        }

        container.style.setProperty('--percentage', percentage);
    } else {
        container.style.display = 'none';
    }
}


const sippingLogic = async (total) => {
    const response = await fetch('https://api.country.is/');
    const { country } = await response.json();
    const container = document.querySelector('.opk-free-shipping.cart-popup');
    if (country === 'BE' || country === 'NL' || country === 'DE') {
        setTimeout(() => {
            const amount_text = container.querySelector('.opk-free-shipping__text span');
            const minimum = Math.round(parseInt(container.dataset.minimum, 10) * (Shopify.currency.rate || 1));
            let percentage = 1;
            const remainingText = container.querySelector('.opk-free-shipping__text-remaining');
            const fullText = container.querySelector('.opk-free-shipping__text-full');
            const icon = container.querySelector('.opk-free-shipping__icon');

            if (total < minimum) {
                percentage = total / minimum;

                if (amount_text) {
                    let remaining = minimum - total;
                    amount_text.innerHTML = `€${remaining / 100}`;
                }
                remainingText.style.display = 'block';
                fullText.style.display = 'none';
                icon.classList.remove('full')
            } else {
                remainingText.style.display = 'none';
                fullText.style.display = 'block';
                icon.classList.add('full')
            }

            container.style.display = 'block';
            container.style.setProperty('--percentage', percentage);
        })
    } else {
        container.style.display = 'none';
    }
}

const cartButtonsListener = () => {
    setTimeout(() => {
        const buttons = document.querySelectorAll('.js-qty__adjust');
        if (buttons) {
            const container = document.querySelector('.opk-free-shipping.cart');
            const totalValue = document.querySelector('.h3.cart__subtotal .money')?.innerText.replace('€', '');
            if (totalValue) {
                const value = totalValue.replace(',', '');
                for (const button of buttons) {
                    button.addEventListener('click', () => {
                        setTimeout(() => {
                            container.dataset.cartTotal = value;
                            sippingLogic(container.dataset.cartTotal);
                        }, 2000)
                    })
                }
            }
        }
    }, 1000)

}

const buttonsListener = () => {
    setTimeout(() => {
        const buttons = document.querySelectorAll('.ajaxcart__qty-adjust');
        const deleteButtons = document.querySelectorAll('.ajaxcart__qty-remove');
        const container = document.querySelector('.opk-free-shipping');
        const totalValue = document.querySelector('.cart__total');
        for (const button of buttons) {
            button.addEventListener('click', () => {
                setTimeout(() => {
                    container.dataset.cartTotal = totalValue.innerText;
                    sippingLogic(container.dataset.cartTotal);
                }, 2000)
            })
        }

        for (const button of deleteButtons) {
            button.addEventListener('click', () => {
                setTimeout(() => {
                    const emptyBlock = document.querySelector('.empty-cart')
                    if (emptyBlock) {
                        container.dataset.cartTotal = '0';
                        sippingLogic(container.dataset.cartTotal);
                    } else {
                        container.dataset.cartTotal = totalValue.innerText;
                        sippingLogic(container.dataset.cartTotal);
                    }
                }, 2000)
            })
        }

    }, 1000)
}

const cartPopupObserver = () => {
    setTimeout(() => {
        const parent = document.querySelector('.right-drawer-vue');
        const observer = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1 && node.matches('.opk-vue')) {
                            const container = document.querySelector('.opk-free-shipping.cart-popup');
                            if (container) {
                                sippingLogic(parseInt(container.dataset.cartTotal, 10));
                            }
                            buttonsListener();

                            const cart = document.querySelector('.opk-drawer');
                            const observer = new MutationObserver((mutations) => {
                                mutations.forEach((mutation) => {
                                    if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
                                        const container = document.querySelector('.opk-free-shipping.cart-popup');
                                        if (container) {
                                            sippingLogic(parseInt(container.dataset.cartTotal, 10));
                                        }
                                        buttonsListener();
                                    }
                                });
                            });

                            observer.observe(cart, {
                                attributes: true,
                                attributeFilter: ['style', 'class'],
                            });
                        }
                    });
                }
            }
        });

        observer.observe(parent, {
            childList: true,
        });

    }, 1000)
}

cartPopupObserver();
cartButtonsListener();
setTimeout(() => {
    const container = document.querySelector('.opk-free-shipping.cart');
    if (container) {
        shippingCartLogic(parseInt(container.dataset.cartTotal, 10));
    }
}, 1000)



